import {
  getLeoUuid,
  LeoUUID,
  getString,
  getLeoTimestamp,
  LeoTimestamp,
} from "@surya-digital/leo-ts-types";

export interface GetAllActiveProjectsPaginationResponseDTO {
  projectId: string;
  projectName: string;
  creator: string;
  surveys: string;
  createdOn: string;
  lastModified: string;
}

export class GetAllActiveProjectsPaginationResponse {
  readonly isGetAllActiveProjectsPaginationResponseGetAllActiveProjectsPaginationResponse: boolean = true;

  readonly projectId: LeoUUID;
  readonly projectName: string;
  readonly creator: string;
  readonly surveys: string;
  readonly createdOn: LeoTimestamp;
  readonly lastModified: LeoTimestamp;


  constructor(
  projectId: LeoUUID, 
  projectName: string, 
  creator: string, 
  surveys: string, 
  createdOn: LeoTimestamp, 
  lastModified: LeoTimestamp
  ) {
    this.projectId = projectId;
    GetAllActiveProjectsPaginationResponse.validateProjectName(projectName);
    this.projectName = projectName;
    GetAllActiveProjectsPaginationResponse.validateCreator(creator);
    this.creator = creator;
    GetAllActiveProjectsPaginationResponse.validateSurveys(surveys);
    this.surveys = surveys;
    this.createdOn = createdOn;
    this.lastModified = lastModified;
  }

  static fromDTO(dto: GetAllActiveProjectsPaginationResponseDTO): GetAllActiveProjectsPaginationResponse {
    const projectId = getLeoUuid(dto, "projectId", InvalidGetAllActiveProjectsPaginationResponseProjectIdError);
    const projectName = getString(dto, "projectName", InvalidGetAllActiveProjectsPaginationResponseProjectNameError);
    const creator = getString(dto, "creator", InvalidGetAllActiveProjectsPaginationResponseCreatorError);
    const surveys = getString(dto, "surveys", InvalidGetAllActiveProjectsPaginationResponseSurveysError);
    const createdOn = getLeoTimestamp(dto, "createdOn", InvalidGetAllActiveProjectsPaginationResponseCreatedOnError);
    const lastModified = getLeoTimestamp(dto, "lastModified", InvalidGetAllActiveProjectsPaginationResponseLastModifiedError);
    return new GetAllActiveProjectsPaginationResponse(
      projectId,
      projectName,
      creator,
      surveys,
      createdOn,
      lastModified
    );
  }

  toDTO(): GetAllActiveProjectsPaginationResponseDTO {
    const dto: GetAllActiveProjectsPaginationResponseDTO = {
        projectId: this.projectId.toDTO(),
        projectName: this.projectName,
        creator: this.creator,
        surveys: this.surveys,
        createdOn: this.createdOn.toDTO(),
        lastModified: this.lastModified.toDTO()
    };
    return dto;
  }
  private static validateProjectName = (projectName: string): void => {
    if(projectName.trim().length === 0) {
      throw new InvalidGetAllActiveProjectsPaginationResponseProjectNameNonEmptyError(
        `Attribute projectName cannot be an empty string.`
      );
    }
  }
  private static validateCreator = (creator: string): void => {
    if(creator.trim().length === 0) {
      throw new InvalidGetAllActiveProjectsPaginationResponseCreatorNonEmptyError(
        `Attribute creator cannot be an empty string.`
      );
    }
  }
  private static validateSurveys = (surveys: string): void => {
    if(surveys.trim().length === 0) {
      throw new InvalidGetAllActiveProjectsPaginationResponseSurveysNonEmptyError(
        `Attribute surveys cannot be an empty string.`
      );
    }
  }
  
}

GetAllActiveProjectsPaginationResponse.prototype.toString = function toString(): string {
  return `GetAllActiveProjectsPaginationResponse(projectId='${this.projectId}',projectName='${this.projectName}',creator='${this.creator}',surveys='${this.surveys}',createdOn='${this.createdOn}',lastModified='${this.lastModified}')`;
};

export class InvalidGetAllActiveProjectsPaginationResponseError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllActiveProjectsPaginationResponseError";
  }
}
export class InvalidGetAllActiveProjectsPaginationResponseProjectIdError extends InvalidGetAllActiveProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllActiveProjectsPaginationResponseProjectIdError";
  }
}

export class InvalidGetAllActiveProjectsPaginationResponseProjectNameError extends InvalidGetAllActiveProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllActiveProjectsPaginationResponseProjectNameError";
  }
}

export class InvalidGetAllActiveProjectsPaginationResponseProjectNameNonEmptyError extends InvalidGetAllActiveProjectsPaginationResponseProjectNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllActiveProjectsPaginationResponseProjectNameNonEmptyError";
  }
}

export class InvalidGetAllActiveProjectsPaginationResponseCreatorError extends InvalidGetAllActiveProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllActiveProjectsPaginationResponseCreatorError";
  }
}

export class InvalidGetAllActiveProjectsPaginationResponseCreatorNonEmptyError extends InvalidGetAllActiveProjectsPaginationResponseCreatorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllActiveProjectsPaginationResponseCreatorNonEmptyError";
  }
}

export class InvalidGetAllActiveProjectsPaginationResponseSurveysError extends InvalidGetAllActiveProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllActiveProjectsPaginationResponseSurveysError";
  }
}

export class InvalidGetAllActiveProjectsPaginationResponseSurveysNonEmptyError extends InvalidGetAllActiveProjectsPaginationResponseSurveysError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllActiveProjectsPaginationResponseSurveysNonEmptyError";
  }
}

export class InvalidGetAllActiveProjectsPaginationResponseCreatedOnError extends InvalidGetAllActiveProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllActiveProjectsPaginationResponseCreatedOnError";
  }
}

export class InvalidGetAllActiveProjectsPaginationResponseLastModifiedError extends InvalidGetAllActiveProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllActiveProjectsPaginationResponseLastModifiedError";
  }
}
